import React, { useState , useEffect, useRef}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import {useClienteMutations} from '../../hooks'
import { ButtonSubmit, FooterPages } from '..';
import Select from 'react-select';
import {getComunas} from "../../services/Comunas";
import {getClientesRutOnBoard, getClientesEmailOnBoard} from '../../services/Clientes';
import rutValidator from '../../utils/validateRut';
import { Toaster,toast } from 'react-hot-toast';
import Geocoder from '../../components/Geocoder/Geocoder';

const initialState = {
empresa:'',
rutCliPro: '',
razonSocial: '',
giro: '',
direccion: '',
telefono: '',
email: '',
descripcion: '',
idComuna: '',
nombreCiudad: '',
contacto: '',
lat:0,
lng:0,
estado: 'Activo',
};

const NuevaCliente = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [comunaData, setComunaData] = useState([]);
  const { addCliente, updateClienteD } = useClienteMutations();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";
  const geocoderRef = useRef();

  useEffect(() => {
    if(vecinoData) setFormData(vecinoData);
  }, [vecinoData]);

 useEffect(()=>{
    const fetchData = async () => {
      const misComunas = await getComunas();
      setComunaData(misComunas);
    };
    fetchData();
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCoordinates = (coords) => {
    console.log('Coordenadas obtenidas:', coords);

      console.log('Coordenadas obtenidas: LNG ', coords[0]);
      console.log('Coordenadas obtenidas: LAT ', coords[1]);

      setFormData({...formData, lat:coords[1], lng:coords[0] });
    // Aquí puedes usar las coordenadas en el componente padre
  };

  const getCurrentCoordinates = () => {
    if (geocoderRef.current) {
      console.log('Coordenadas actuales:', geocoderRef.current.getCoordinates());
    }
  };

  const comunaOptions = comunaData.map((item) => ({
    value: item._id,
    label: `${item.codigoComuna} - ${item.nombreComuna}`,
  }));

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones
    if( !rutValidator(formData.rutCliPro))
      {
        toast.error('RUT Ingresado no es Válido!');
        return;
      }

    if(!vecinoData._id) 
    {
      // console.log('crear Cliente' + formData.rutCliPro);
      const clienteExistente = await getClientesRutOnBoard(formData.rutCliPro);
      // console.log('clienteExistente -> ' + JSON.stringify(clienteExistente));
      if(clienteExistente.length > 0) {
        toast.error('Cliente ya existe con el RUT ingresado!');
        return;
      }

      const emailExiste = await getClientesEmailOnBoard(formData.email);
      if(emailExiste.length > 0) {
        toast.error('El Email ingresado ya esta asociado a un cliente!');
        return;
      }
      
      //dispatch(createProduct(prodData));    
      // console.log('crear VECINO');
       await addCliente.mutateAsync( formData );
    } else
    {
      // dispatch(updateProduct(prodData));    
       await updateClienteD.mutateAsync( formData );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevasucursal );
   // window.location.reload();
    //navigate('/inventario');
  }
  
  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
        <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-white w-full md:w-2/3 p-8">
          
            <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
                <p className="text-gray-800 font-semibold text-base md:text-lg">
                  {!vecinoData ? "Nuevo" : "Editar"} Cliente
                </p>
              </div>

              <button
                type="button"
                onClick={() => setIsClicked(!isClicked.nuevasucursal)}
                className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
                aria-label="Cerrar"
              >
                <MdOutlineCancel className="text-xl md:text-2xl" />
              </button>
            </div>

          <div className="mt-5 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                <div className="flex flex-col">
                  <p className="text-xs text-gray-600"> Rut </p>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="rutCliPro"
                      value= {formData.rutCliPro}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="col-span-3">
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Nombre </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="razonSocial"
                        value= {formData.razonSocial}
                        required
                        onChange={handleChange}
                      />
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-5 gap-4" >
                  <div className="col-span-3">
                    <div className="flex flex-col">
                      <p className="text-xs text-gray-600"> Dirección </p>
                      <input
                          className={inputClass}
                          type="text"
                          placeholder=""
                          name="direccion"
                          value= {formData.direccion}
                          onChange={handleChange}
                        />
                    </div> 
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Latitud </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="lat"
                        value= {formData.lat}
                        onChange={handleChange}
                      />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Longitud </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="lng"
                        value= {formData.lng}
                        onChange={handleChange}
                      />
                  </div>
              </div>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
              <div className="flex flex-col">
                  <Geocoder 
                    ref={geocoderRef}
                    onCoordinatesChange={handleCoordinates}
                  />

              </div>
            </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
              <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Comuna</label>
                    <Select
                      options={comunaOptions}
                      value={comunaOptions.find((option) => option.value === formData.idComuna)}
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          const comunaSeleccionada = comunaData.find(c => c._id === selectedOption.value);

                          setFormData((prev) => ({
                            ...prev,
                            idComuna: selectedOption.value,
                            nombreCiudad: comunaSeleccionada?.nombreCiudad || '',
                          }));
                        } else {
                          // Si se limpia el campo
                          setFormData((prev) => ({
                            ...prev,
                            idComuna: '',
                            nombreCiudad: '',
                          }));
                        }
                      }}
                      className="text-xs"
                      placeholder="Buscar ..."
                      isClearable
                      disabled = {!vecinoData._id ? false : true}
                    />

                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Ciudad </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="nombreCiudad"
                        value= {formData.nombreCiudad}
                        required
                        onChange={handleChange}
                      />
                  </div> 
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Contacto </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="Contacto"
                        name="contacto"
                        value= {formData.contacto}
                        onChange={handleChange}
                      />
                  </div>
              </div>
              <div className="flex justify-between items-center mt-2 m-1 border-t-1 border-color"></div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Teléfono </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="Teléfono"
                        name="telefono"
                        value= {formData.telefono}
                        onChange={handleChange}
                      />
                  </div>  
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> email </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="email"
                        name="email"
                        value= {formData.email}
                        onChange={handleChange}
                      />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Estado </p>
                      <select className={inputClass} name="estado" value= {formData.estado} required onChange={handleChange}>
                        <option value="Activo">Activo</option>
                        <option value="Pendiente">Pendiente</option>
                        <option value="Eliminado">Eliminado</option>
                      </select>
                  </div>
              </div>

              <div className="grid grid-cols-4 gap-4" >
                  <div className="flex flex-col">
                      <ButtonSubmit
                        color="white"
                        bgColor={currentColor}
                        text= { !vecinoData ? "Crear Nuevo": "Guardar Cambios"}  
                        borderRadius="10px"
                        onClick = {handleSubmit}
                        width="full"
                      />   
                  </div>
              </div>   
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />         
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevaCliente;